var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"page",staticClass:"page a403-page"},[_c('p',{staticClass:"a403-message"},[_vm._v("Access denied (403)")])])
}
var staticRenderFns = []

export { render, staticRenderFns }